import React from 'react';
import ButtonArrow from '../Components/button-arrow';
import CLinkHover from '../Components/link-hover';
import ViewManager from '../Components/view-manager';

const FGrilleVideos = ({ cta, videos, marginImage }) => {

    const [ref, visible] = ViewManager();

    const Article = (info) => {
        return (
            <>
                <div className="f-grillevideos_article_subarticle">
                    <p className="f-grillevideos_article_date">{info.date}</p>
                    <p className="f-grillevideos_article_titre">{info.text}</p>
                </div>
                <p className="f-grillevideos_article_visuel">
                    <span className="f-grillevideos_article_visuelContainer">
                        {
                            info.video && <img src={info.video.src} alt={info.video.alt} />
                        }
                    </span>
                </p>
            </>
        )
    }

    return (
        <div className={`flexible flexible--${marginImage} f-grillevideos container ${visible ? "blocInView" : ""}`} ref={ref}>
            <div className="subcontainer">
                <div className="f-grillevideos_content">
                    {
                        videos.filter((item, index) => index < 4).map((item, index) => <CLinkHover withZoom={true} to={item.link.url} isNotLink={!item.link.internal} target={item.link.target} type="plus" key={index} className="f-grillevideos_article">{Article(item)}</CLinkHover>)
                    }
                </div>
                <p className="f-grillevideos_bouton"><ButtonArrow cta={cta} /></p>
            </div>
        </div>
    )
};

export default FGrilleVideos;